module.exports = __webpack_public_path__ + "img/resp-contact.8b3c42d5.svg";